import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { UtilService } from 'src/app/modules/shared/services/util.service';
import { CouponsService } from 'src/app/modules/retailer/services/coupons.service';

@Component({
  selector: 'app-show-coupon',
  templateUrl: './show-coupon.component.html',
  styleUrls: ['./show-coupon.component.scss']
})
export class ShowCouponComponent implements OnInit {

  @Input() module: string; // (CPG/RETAILER)
  @Input() couponData: any; // Coupon details (used for displayType = grid)
  @Input() couponListData: any; // Coupon list (used for displayType = list)
  @Input() couponStoreId: any; // Coupon store id
  @Input() displayType: any; // Display type (grid/list)
  @Output() couponSelection = new EventEmitter(); // Coupon selection event
  @Output() couponReviewAction = new EventEmitter(); // Coupon review action event

  public couponPreviewModal: BsModalRef;
  public couponPreviewModalData: any;
  public reviewing: boolean = false;

  constructor(
    private _utilService: UtilService,
    private _couponsServiceRetailer: CouponsService,
    private _modalService: BsModalService,
  ) { }

  ngOnInit(): void {
    // Set display type grid if not passed
    if(!this.displayType){
      this.displayType= 'grid';
    }
  }

  // Show coupon preview modal
  async showCouponPreviewModal(coupon: any, template: TemplateRef<any>) {
    // Reset data
    this.couponPreviewModalData = coupon;
    this.reviewing = false; 

    this.couponPreviewModal = this._modalService.show(template, {class: 'modal-lg'});
  }

  // Hide coupon preview modal
  hideCouponPreviewModal(): void {
    this.couponPreviewModal.hide();
  }

  // On review
  async onReview(reviewStatus: any){
    if (this.module == 'RETAILER') { // Review action only for retailer
      this.reviewing = true;

      let loginData: any = await this._utilService.getStorageData('R_LOGIN');

      let reviewCouponBody = {
        provider_type: loginData.user_details.provider_type,
        provider_id: loginData.user_details.provider_id,
        store_id: this.couponStoreId,
        coupon_id: this.couponPreviewModalData.coupon_id,
        accept: reviewStatus
      };

      this._couponsServiceRetailer.reviewCoupon(loginData.token, reviewCouponBody).subscribe(async reviewCouponResponse => {
        this.reviewing = false;

        if (reviewCouponResponse.status === true) { // Success
          if (reviewStatus == 'true') { // Accept
            this._utilService.showToast('Coupon is accepted', '', 'success', {});

            this.couponReviewAction.emit({ coupon : this.couponPreviewModalData, action: 'accepted' });
          } else { // Reject
            this._utilService.showToast('Coupon is rejected', '', 'success', {});

            this.couponReviewAction.emit({ coupon : this.couponPreviewModalData, action: 'rejected' });
          }

          this.hideCouponPreviewModal();
        } else {
          this._utilService.showToast(reviewCouponResponse.message, '', 'success', {});
        }
      }, error => { // Error from getStores
        this.reviewing = false;
      });
    }
  }

  /*// On coupon selection
  async onCouponSelect() {
    this.couponSelection.emit({ coupon : this.couponData });
  }*/


}
